import { Record } from 'immutable';

export const ALERTS_REDUCER_KEY = 'alertsStore';

export const IconBgColors = Object.freeze({
  COLOR1: 'color1',
  COLOR2: 'color2',
  COLOR3: 'color3',
  COLOR4: 'color4',
  COLOR5: 'color5',
  COLOR6: 'color6',
  COLOR7: 'color7',
  COLOR8: 'color8',
  COLOR9: 'color9',
});
// eslint-disable-line no-undef

export const mkAlert = Record({
  id: undefined,
  isDeleted: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  group: undefined,
  type: undefined,
  title: undefined,
  icon: undefined,
  iconBgColor: undefined,
  message: undefined,
  isRead: false,
  isDismissed: false,
  deepLinkUri: undefined,
  deepLinkComponent: undefined,
  deepLinkEntityId: undefined,
});
